import styles from './FooterPageLegalDisclaimers.module.scss';

import React, { FC, HTMLAttributes } from 'react';
import cx from 'classnames';
import { TextV2 } from 'components/TextV2/TextV2';

type FooterPageLegalDisclaimersProps = HTMLAttributes<HTMLDivElement> & {
  disclaimers?: string[];
};

export const FooterPageLegalDisclaimers: FC<FooterPageLegalDisclaimersProps> = ({
  disclaimers,
  className,
  ...props
}) => {
  if (!disclaimers?.length) return null;

  return (
    <div className={cx(styles.footerPageLegalDisclaimersGroup, className)} {...props}>
      <ol>
        {disclaimers.map(disclaimer => (
          <li key={disclaimer}>
            <TextV2 isMarkdown value={disclaimer} />
          </li>
        ))}
      </ol>
    </div>
  );
};
